import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'
import ButtonControl from '../../button-control'
import Checkbox from '../../ui-components/Checkbox'
import { Model } from '../../table/types'

interface Props {
  columns: Model[],
  showModal: boolean,
  onApply: (columns: Model[]) => void,
  onClose: () => void,
  onResetToDefault: () => void,
  toggleColumn: (accessor: string, checked: boolean) => void
}

const SelectColumnsModal = (props: Props) => {
  const { columns, showModal, onApply, onClose, onResetToDefault, toggleColumn } = props

  function formatColumns () {
    return columns.map((column: Model) => {
      return <div className='overview-select-columns-modal__column'>
        <Checkbox
          label=''
          onUpdate={(checked: boolean) => { toggleColumn(column.accessor as string, checked) }}
          qaClasses='qa-select-all'
          checked={!column.isHidden}
          disabled={column.isFixed}
        />
        {column.header}
      </div>
    })
  }

  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title='Custom table view' onClose={onClose} />
      <ModalBody>{formatColumns()}</ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Apply'
          variant='brand'
          onClick={onApply}
          class='qa-apply-columns'
          newStyle
          size='medium'
        />
        <ButtonControl
          title='Cancel'
          onClick={onClose}
          newStyle
          size='medium'
        />
        <ButtonControl
          title='Reset to default'
          onClick={onResetToDefault}
          class='qa-reset-columns'
          newStyle size='medium'
        />
      </ModalFooter>
    </Modal>
  )
}

export default SelectColumnsModal
